// Anthology: cap the thumbnail rail to the main image's height (in the
// thumbnails-left desktop layout added in product-steps.css) and add
// up/down buttons to scroll through any thumbnails that don't fit, instead
// of letting the rail run longer than the photo beside it.
(function () {
  function setup(gallery) {
    if (gallery.dataset.thumbsNavInit) return;
    var viewer = gallery.querySelector('.media-gallery__viewer');
    var thumbsWrap = gallery.querySelector('.media-gallery__thumbs');
    var thumbsList = thumbsWrap ? thumbsWrap.querySelector('.media-thumbs') : null;
    if (!viewer || !thumbsWrap || !thumbsList) return;
    gallery.dataset.thumbsNavInit = 'true';

    var upBtn = document.createElement('button');
    upBtn.type = 'button';
    upBtn.className = 'media-thumbs-nav media-thumbs-nav--up';
    upBtn.setAttribute('aria-label', 'Scroll thumbnails up');
    upBtn.innerHTML = '&#9650;';
    upBtn.hidden = true;

    var downBtn = document.createElement('button');
    downBtn.type = 'button';
    downBtn.className = 'media-thumbs-nav media-thumbs-nav--down';
    downBtn.setAttribute('aria-label', 'Scroll thumbnails down');
    downBtn.innerHTML = '&#9660;';
    downBtn.hidden = true;

    thumbsWrap.appendChild(upBtn);
    thumbsWrap.appendChild(downBtn);

    function scrollStep() {
      var item = thumbsList.querySelector('.media-thumbs__item');
      return item ? item.getBoundingClientRect().height + 8 : 84;
    }

    upBtn.addEventListener('click', function () {
      thumbsList.scrollBy({ top: -scrollStep(), behavior: 'smooth' });
    });
    downBtn.addEventListener('click', function () {
      thumbsList.scrollBy({ top: scrollStep(), behavior: 'smooth' });
    });

    function updateNavVisibility() {
      var canScroll = thumbsList.scrollHeight > thumbsList.clientHeight + 1;
      upBtn.hidden = !canScroll || thumbsList.scrollTop <= 0;
      downBtn.hidden = !canScroll || thumbsList.scrollTop + thumbsList.clientHeight >= thumbsList.scrollHeight - 1;
    }

    thumbsList.addEventListener('scroll', updateNavVisibility);

    function syncHeight() {
      if (window.matchMedia('(min-width: 990px)').matches) {
        var h = viewer.getBoundingClientRect().height;
        if (h > 0) {
          // A percentage height on thumbsList wouldn't resolve here since
          // thumbsWrap is only constrained by max-height (auto height), not
          // an explicit height - set both directly in px instead.
          thumbsWrap.style.maxHeight = h + 'px';
          thumbsList.style.maxHeight = h + 'px';
        }
      } else {
        thumbsWrap.style.maxHeight = '';
        thumbsList.style.maxHeight = '';
      }
      updateNavVisibility();
    }

    syncHeight();
    window.addEventListener('resize', syncHeight);
    document.addEventListener('on:variant:change', function () {
      setTimeout(syncHeight, 60);
    });
    document.addEventListener('shopify:section:load', function () {
      setTimeout(syncHeight, 60);
    });

    var mainImg = viewer.querySelector('img');
    if (mainImg && !mainImg.complete) {
      mainImg.addEventListener('load', syncHeight, { once: true });
    }
  }

  function init() {
    document.querySelectorAll('.media-gallery').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
